import { useSettings } from '@/store/settingStore';
import { cn } from '@/utils';
import type { ReactNode } from 'react';
import AccountDropdown from '../components/account-dropdown';
import BreadCrumb from '../components/bread-crumb';
import NoticeButton from '../components/notice';
import SearchBar from '../components/search-bar';
import SettingButton from '../components/setting-button';
import {TimezoneSelector} from '../components/TimezoneSelector';

interface HeaderProps {
  headerLeftSlot?: ReactNode;
}

export default function Header({ headerLeftSlot }: HeaderProps) {
  const { breadCrumb } = useSettings();
  return (
    <header
      data-slot="slash-layout-header"
      className={cn(
        'sticky z-app-bar top-0 right-0 left-auto flex items-center justify-between px-4 ml-[1px]',
        'h-[var(--layout-header-height)] grow-0 shrink-0',
        'border-b bg-background/75 shadow-sm backdrop-blur-xl',
      )}
    >
      <div className="flex items-center">
        {headerLeftSlot}

        <div className="hidden md:block ml-4">{breadCrumb && <BreadCrumb />}</div>
      </div>

      <div className="flex items-center gap-1">
        <TimezoneSelector />
        <SearchBar />
        <SettingButton />
        <AccountDropdown />
      </div>
    </header>
  );
}
